var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main",
      class: { hasNavbar: _vm.isShowNav, hasAppTip: _vm.isShowAppTip },
    },
    [
      _c("app-tip", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowAppTip,
            expression: "isShowAppTip",
          },
        ],
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "router-transition", mode: "out-in" } },
        [
          _c(
            "keep-alive",
            { attrs: { max: 2 } },
            [_c("router-view", { ref: "keepAlive" })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowNav ? _c("nav-bar") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }